import { jsxs as e, jsx as l } from "react/jsx-runtime";
const v = (a) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          fillRule: "evenodd",
          d: "M15.305 14.477h.003l.57 1.044A1 1 0 0 1 16 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h3a1 1 0 0 1 .878.521l.703 1.29a2.003 2.003 0 0 0 .39 3.171L11 9v.002l-.03.017a2 2 0 1 0 2 3.464l.03-.017v.035a2 2 0 0 0 2.305 1.977M11 18a1 1 0 1 0-2 0v.01a1 1 0 1 0 2 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          fillRule: "evenodd",
          d: "M16 5.5a1 1 0 1 0-2 0v.672a3 3 0 0 0-.949.547l-.581-.335a1 1 0 1 0-1 1.732l.58.335a3 3 0 0 0 0 1.098l-.58.335a1 1 0 1 0 1 1.732l.581-.335a3 3 0 0 0 .949.547v.672a1 1 0 1 0 2 0v-.672c.346-.122.668-.307.95-.548l.583.336a1 1 0 1 0 1-1.732l-.584-.337a3 3 0 0 0 0-1.095l.583-.336a1 1 0 1 0-1-1.732l-.582.336a3 3 0 0 0-.95-.548zm-1.886 3.037a1 1 0 1 0 1.772.926 1 1 0 0 0-1.772-.926",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
export {
  v as default
};
